export function splitMinutesToDHM(total) {
  if (!total || total <= 0) return { d: '', h: '', m: '' };
  const d = Math.floor(total / 1440);
  const r = total - d * 1440;
  const h = Math.floor(r / 60);
  const m = r % 60;
  return {
    d: d > 0 ? String(d) : '',
    h: h > 0 ? String(h) : '',
    m: m > 0 ? String(m) : '',
  };
}
